import GetPrototypeModuleOverviewRequestModelBase from '../_generated/modelBases/get-prototype-module-overview-request-model-base';

export default class GetPrototypeModuleOverviewRequestModel extends GetPrototypeModuleOverviewRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
